<template>
  <v-container
  >
    <v-row
      v-if="isClient"
    >
      <v-col cols="12" class="pb-0 heading">
        {{$t('your_api_credentials')}}
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          outlined
          hide-details
          label="API Key"
          ref="apiKey"
          append-outer-icon="mdi-content-copy"
          @click:append-outer="copyApiKey"
          readonly
          v-model="user.api_key"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          outlined
          hide-details
          label="API Secret"
          ref="apiSecret"
          :type="viewSecret ? 'text' : 'password'"
          append-icon="mdi-eye"
          @click:append="viewSecret = !viewSecret"
          append-outer-icon="mdi-content-copy"
          @click:append-outer="copyApiSecret"
          readonly
          v-model="user.api_secret"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
        class="my-auto"
      >
        <v-btn
          color="primary"
          :loading="regenApiBusy"
          @click.stop="apiDialog = true"
        >
          {{$t('regen_secret')}}
          <template>
            <v-dialog
              v-model="apiDialog"
              max-width="290"
            >
              <v-card>
                <v-card-title class="headline">{{$t('confirm_title')}}</v-card-title>

                <v-card-text>
                  {{$t('regen_secret_confirmation')}}
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    text
                    :loading="regenApiBusy"
                    @click="apiDialog = false"
                  >
                    {{$t('cancel')}}
                  </v-btn>

                  <v-btn
                    color="primary"
                    :loading="regenApiBusy"
                    @click="regenApiSecret"
                  >
                    {{$t('continue')}}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row
      v-if="isClient"
      align="center"
    >
      <v-col cols="3">
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-account-tie</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('cs_agent_count')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.client_csa_count}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row
      v-if="isRoot || isManager"
      align="center"
      justify="center"
    >
      <v-col>
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-account-tie</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('manager_count')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.manager_count}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-account-hard-hat</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('cs_agent_count')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.cs_agent_count}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-account-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('client_count')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.client_count}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-credit-card</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('bank_card_count')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.bank_card_count}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <v-card :to="{name: 'home'}">
          <v-list disabled>
            <v-list-item-group color="primary">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon x-large>mdi-api</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('active_gateway')}}</v-list-item-subtitle>
                  <v-list-item-content>{{overview.active_gateway}}</v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row v-if="authenticated">
      <v-col>
        <v-card>
          <v-tabs v-model="selected_transaction" class="mt-2">
            <v-tab v-for="trx of availableTransactionTypes" :key="trx">
              {{$t(getKeyByValue(TransactionType, trx))}}
            </v-tab>

            <v-tabs-items v-model="selected_transaction">
              <v-row class="mx-2">
                <v-col offset="4">
                  <v-datetime-picker
                    v-model="fromDate"
                    :text-field-props="{prependIcon: 'mdi-calendar'}"
                    :label="$t('date_from')"
                    :ok-text="$t('confirm')"
                    :clear-text="$t('clear')"
                    @input="fetchOverview()"
                  >
                    <template v-slot:dateIcon>
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template v-slot:timeIcon>
                      <v-icon>mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
                <v-col>
                  <v-datetime-picker
                    v-model="toDate"
                    :text-field-props="{prependIcon: 'mdi-calendar'}"
                    :label="$t('date_to')"
                    :ok-text="$t('confirm')"
                    :clear-text="$t('clear')"
                    @input="fetchOverview()"
                  >
                    <template v-slot:dateIcon>
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template v-slot:timeIcon>
                      <v-icon>mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
              </v-row>
              <v-data-table
                :headers="summaryHeaders"
                :items="
                  overview && 
                  overview.transaction &&
                  overview.transaction[availableTransactionTypes[selected_transaction]] && 
                  overview.transaction[availableTransactionTypes[selected_transaction]].length > 0
                    ? overview.transaction[availableTransactionTypes[selected_transaction]]
                    : []
                "
              >
                <template v-slot:item.currency_code="{ item }">
                  <v-chip> {{ item.currency_code }} </v-chip>
                </template>
                <template v-slot:item.completed_trx_net_amt="{ item }">
                  {{ toMonetaryString(item.completed_trx_net_amt) }}
                </template>
                <template v-slot:item.completed_trx_commission="{ item }">
                  {{ toMonetaryString(item.completed_trx_commission) }}
                </template>
              </v-data-table>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import axios from 'axios'
import transactionMixins from '../mixins/transactionMixins'
import { toMonetaryString } from '../utils/utilsMonetary';

export default {
  name: 'home',
  mixins: [transactionMixins],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      authenticated: 'auth/check',
      isRoot: 'auth/isRoot',
      isManager: 'auth/isManager',
      isCsAgent: 'auth/isCsAgent',
      isClient: 'auth/isClient',
    }),
    summaryHeaders() {
      return [
        {
          text: this.$t('currency'),
          value: 'currency_code',
        },
        {
          text: this.$t('completed_transaction_count'),
          value: 'completed_trx_count',
        },
        {
          text: this.$t('completed_transaction_amount'),
          value: 'completed_trx_net_amt',
        },
        {
          text: this.$t('completed_transaction_commission'),
          value: 'completed_trx_commission',
        },
      ]
    }
  },
  mounted () {
    this.fetchOverview();

    this.availableTransactionTypes = [
      this.TransactionType.COLLECT,
      this.TransactionType.PAY,
      this.TransactionType.WITHDRAW,
    ];
  },
  data: function () {
    return {
      availableTransactionTypes: [],
      selected_transaction: null,
      apiDialog: false,
      regenApiBusy: false,
      viewSecret: false,
      overview: {
        "transaction": {},
        "manager_count": 0,
        "cs_agent_count": 0,
        "client_count": 0,
        "bank_card_count": 0,
        "active_gateway": 0,
        "cs_agent_b_count": 0
      },
      fromDate: undefined,
      toDate: undefined,
    }
  },
  methods: {
    toMonetaryString,
    async fetchOverview(){
      ///app/api/overview
      this.busy = true;
      const _this = this;
      const fromDate = this.fromDate ? Date.parse(this.fromDate) : undefined;
      const toDate = this.toDate ? Date.parse(this.toDate) : undefined;
      await axios.get(
          '/app/api/overview', 
          { params: { fromDate, toDate } }
        )
        .then(function (response) {
          // console.log(response.data.data); //eslint-disable-line
          _this.overview = response.data.data;
        })
        .catch(function (error) {
          _this.$store.dispatch('snackbar/openSnackbar', {
            message: error.response.data.message,
            color: 'error',
          })
        })
        .finally(function () {
          _this.busy = false;
        })
    },
    async regenApiSecret () {
      this.regenApiBusy = true
      const _this = this

      await axios.post(`/app/api/client/${this.user.user_id}/chgapisecret`)
        .then(function (response) {
          _this.$store.dispatch('auth/updateUserApiSecret', response.data.data);
          _this.apiDialog = false

          _this.$store.dispatch('snackbar/openSnackbar', {
            message: response.data.message,
            color: 'success',
          })
        })
        .catch(function (error) {
          _this.$store.dispatch('snackbar/openSnackbar', {
            message: error.response.data.message,
            color: 'error',
          })
        })
        .finally(function () {
          _this.regenApiBusy = false;
        })
    },
    copyApiKey() {
      this.copyToClipboard(this.user.api_key, 'API Key')
    },
    copyApiSecret() {
      this.copyToClipboard(this.user.api_secret, 'API Secret')
    },
    copyToClipboard(value, type) {
      navigator.clipboard.writeText(value).then(() => {
        this.$store.dispatch('snackbar/openSnackbar', {
          message: this.$t('copy_success', [type]),
          color: 'success',
        })
      });
    },
  }
}
</script>
